import { Button, Col, Row } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import BotonSubmit from "../../../../components/Boton/BotonSubmit";
import { ServiciosSelect } from "../../../../components/select/ServiciosSelect";
import { startCrearServicioSigsa } from "../../../../context/actions/gnpApiActions";
import { CuentasEspecialesSelect } from "../../../../components/select/CuentasEspecialesSelect";

export const BotonConfirmar = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [servicioID, setServicioID] = useState();
  const [cuentaEspecialGNP, setCuentaEspecialGNP] = useState();

  const [showErr, setShowErr] = useState(false);
  const { tipoServicio } = useSelector(
    (state) => state.gnpApiReducer.siniestro
  );
  const { catServiciosGNP } = useSelector((state) => state.gnpApiReducer);
  const todo = useSelector((state) => state.gnpApiReducer.siniestro);

  console.log(todo);

  //
  const handleChange = (val) => setServicioID(val);

  const isDisabled = () => {
 
    if (!servicioID) return true;
    
  
    return false;
  };
  //
  const submit = () => {
    if (!servicioID) {
      setShowErr(true);
      return;
    }

    dispatch(startCrearServicioSigsa(servicioID, cuentaEspecialGNP)).then(
      (asistenciaID) => {
        if (asistenciaID) history.push(`/detalleAsistencia/${asistenciaID}`);
      }
    );
  };

  ///////////
  return (
    <Row gutter={10} style={{ marginTop: 30 }}>
      <Col span={6}>
        <ServiciosSelect
          arr={catServiciosGNP}
          onChange={handleChange}
          value={servicioID}
          label={`Servicio: ${tipoServicio}`}
        />
      </Col>

      {todo?.cuentaEspecial === 1 && (
        <Col span={4}>
          <CuentasEspecialesSelect
            onChange={({ target }) => setCuentaEspecialGNP(target.value)}
          />
        </Col>
      )}

      <Col span={6} style={{ paddingTop: 22 }}>
        <Button
          disabled={isDisabled()}
          onClick={submit}
          tituloBoton="Confirmar Servicio"
          type="primary"

        >Confirmaar Servicio</Button>
      </Col>

      <Col span={6} style={{ paddingTop: 22 }}>
        {showErr && (
          <span style={{ color: "#ca2228" }}>Escoge el servicio</span>
        )}
      </Col>
    </Row>
  );
};
